import React, { Component } from 'react'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  TextField
} from '@material-ui/core'
import axios from 'axios'
import moment from 'moment'
import {
  COUNTRIES,
  EMPLOYER_ACTIVITY,
  FB_API_URL,
  CP_API_URL,
  getUserBranches
} from '../lib/env'
import CustomNumberFormat from '../components/custom_number_format'
import { isAlphaNumeric, isNumeric, validateInput } from '../lib/util'
import { withSnackbar } from 'notistack'
import { flowRight } from 'lodash'
import InputMask from 'react-input-mask'

class CreateCreditRequest extends Component {
  constructor(props) {
    super(props)

    this.state = {
      token: localStorage.getItem('token'),
      // Сведения о кредите
      creditPurpose: null,
      totalPrice: '',
      downPaymentAmount: null,
      creditAmount: '',
      creditTerm: null,
      repaymentMethod: 'Аннуитетный',
      simplifiedFin: null,
      dealerName: null,

      // Обеспечение
      carBrand: '',
      carModel: '',
      carManufactureCountry: null,
      carYear: '',
      carWheel: 'Левый',
      carMileage: '',
      carVinCode: '',

      // Сведения о Заемщике
      clientFirstname: '',
      clientLastname: '',
      clientPatronymic: '',
      clientIIN: null,
      clientDateOfBirth: '',
      clientGender: '',
      clientCitizenship: 'Казахстан',
      clientEducationLevel: null,
      clientPlaceOfBirth: 'Казахстан',
      clientResidency: '',
      clientDocumentInfo: null,
      clientDocumentIssueDate: null,
      clientDocumentExpireDate: null,
      clientDocumentNumber: null,
      clientDocumentIssuer: null,
      clientChangedName: null,
      clientIsPledger: null,
      clientMaritalStatus: null,
      clientDependentsNumber: null,
      clientChildCount: null,
      clientSpouseInfo: null,
      clientRegistrationAddress: '',
      clientAddressRegion: '',
      clientAddressTown: '',
      clientAddressDistrict: '',
      clientAddressStreet: '',
      clientAddressHouse: '',
      clientAddressApartmentNo: '',
      clientActualAddress: '',
      clientRegistrationAddressEqualsActualAddress: 'Нет',
      clientRightOfResidence: null,
      clientMobilePhoneNumber: null,
      clientWorkPhoneNumber: null,

      // Информация по супругу/супруге
      spouseFirstname: '',
      spouseLastname: '',
      spousePatronymic: '',
      spouseIIN: '',
      spouseDateOfBirth: null,

      // Информация о работе
      employerFullName: null,
      employerActivity: null,
      jobPositionCategory: null,
      jobPosition: null,
      employmentStatus: null,
      workExperienceInMonths: null,
      workExperienceInMonthsAtLastPosition: null,

      // Информация о среднемесячных доходах и расходах
      mainIncome: null,
      spouseIncome: null,
      totalIncome: '',

      // Дополнительные контакты
      contact1Name: null,
      contact1PhoneNumber: null,
      contact1Relationship: null,
      contact2Name: null,
      contact2PhoneNumber: null,
      contact2Relationship: null,
      contact3Name: null,
      contact3PhoneNumber: null,
      contact3Relationship: null,

      branchCode: '',
      userBranches: [],

      regions: [],
      districts: [],
      towns: [],

      selectedCarsFromSale: [],
      selectedCarId: null,

      newCars: [
        {
          marka: 'OMODA',
          model: 'S5'
        },
        {
          marka: 'OMODA',
          model: 'C5'
        },
        {
          marka: 'RENAULT',
          model: 'Arkana'
        },
        {
          marka: 'RENAULT',
          model: 'Duster'
        },
        {
          marka: 'RENAULT',
          model: 'Kaptur'
        },
        {
          marka: 'RENAULT',
          model: 'Logan'
        },
        {
          marka: 'RENAULT',
          model: 'Sandero'
        },
        {
          marka: 'RENAULT',
          model: 'Koleos'
        },
        {
          marka: 'LADA',
          model: 'Granta'
        },
        {
          marka: 'LADA',
          model: 'Largus'
        },
        {
          marka: 'LADA',
          model: 'Niva Travel'
        },
        {
          marka: 'LADA',
          model: 'Niva 4x4'
        },
        {
          marka: 'LADA',
          model: 'Vesta'
        },
        {
          marka: 'LADA',
          model: 'XRAY'
        },
        {
          marka: 'Chevrolet',
          model: 'Cobalt'
        },
        {
          marka: 'Chevrolet',
          model: 'Damas'
        },
        {
          marka: 'Chevrolet',
          model: 'Equinox'
        },
        {
          marka: 'Chevrolet',
          model: 'Lacetti'
        },
        {
          marka: 'Chevrolet',
          model: 'Malibu'
        },
        {
          marka: 'Chevrolet',
          model: 'Nexia'
        },
        {
          marka: 'Chevrolet',
          model: 'Onix'
        },
        {
          marka: 'Chevrolet',
          model: 'Spark'
        },
        {
          marka: 'Chevrolet',
          model: 'Tracker'
        },
        {
          marka: 'GAC',
          model: 'GS5'
        },
        {
          marka: 'GAC',
          model: 'GS8'
        },
        {
          marka: 'JAECOO',
          model: 'J7'
        }
      ]
    }
  }

  componentDidMount() {
    this.getUserBranches()
    this.getRegions()
    this.getCarsFromSale()
  }

  getCarsFromSale() {
    if (!this.props.sale) {
      return
    }

    if (!this.props.sale.steps) {
      let selectedCarsFromSale = []
      this.props.sale.selectedCars.map(car => selectedCarsFromSale.push(car))
      this.setState({ selectedCarsFromSale })
    }
  }

  populateCarRelatedFields(selectedCarId) {
    let selectedCar = this.state.selectedCarsFromSale.filter(
      car => car.id === selectedCarId
    )[0]

    this.setState({
      carBrand: selectedCar.marka.name,
      carModel: selectedCar.model.name,
      carYear: selectedCar.year,
      carWheel: selectedCar.steering === 1 ? 'Левый' : 'Правый',
      carMileage: selectedCar.mileage,
      carVinCode: selectedCar.vin,
      selectedCarName:
        selectedCar.marka.name +
        ' ' +
        selectedCar.model.name +
        ' ' +
        selectedCar.year
    })
  }

  populateNewCar(car) {
    let marka = car.split('#')[0]
    let model = car.split('#')[1]

    if (marka === 'Chevrolet') {
      this.setState({
        dealerName: 'ТОО "Сарыарка АвтоПром"'
      })
    } else {
      this.setState({
        dealerName: 'ТОО ОРИОН ДИСТРИБЬЮШН'
      })
    }

    this.setState({
      carBrand: marka,
      carModel: model,
      carWheel: 'Левый',
      carMileage: 0
    })
  }

  getRegions() {
    let self = this
    axios
      .get(FB_API_URL + '/carfin/kato/getRegions', {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
      .then(function (response) {
        self.setState({ regions: response.data })
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  getDistricts(region) {
    let self = this
    axios
      .get(FB_API_URL + '/carfin/kato/getDistricts', {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        params: { region: region }
      })
      .then(function (response) {
        self.setState({ districts: response.data })
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  getTowns(district) {
    let self = this
    axios
      .get(FB_API_URL + '/carfin/kato/getTowns', {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        params: { district: district }
      })
      .then(function (response) {
        self.setState({ towns: response.data })
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  getUserBranches() {
    let userBranches = getUserBranches(this.state.token)
    this.setState({ userBranches })
    if (userBranches.length === 1) {
      this.setState({ branchCode: userBranches[0].branchCode })
    }
  }

  handleUpload = name => event => {
    let self = this
    const file = event.target.files[0]
    const formData = new FormData()
    formData.append(name, file, '123456')
    axios
      .post(CP_API_URL + '/vision/idScan', formData, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(function (response) {
        console.log(response.data)
        if (name === 'front') {
          self.setState({
            clientFirstname: response.data?.fname,
            clientLastname: response.data?.lname,
            clientPatronymic: response.data?.patronymic,
            clientIIN: response.data?.iin,
            clientDateOfBirth: moment(
              response.data?.bdate,
              'DD.MM.YYYY'
            ).format('YYYY-MM-DD')
          })
        }
        if (name === 'back') {
          self.setState({
            clientDocumentInfo: '04',
            clientDocumentIssueDate: moment(
              response.data?.issueDate,
              'DD.MM.YYYY'
            ).format('YYYY-MM-DD'),
            clientDocumentExpireDate: moment(
              response.data?.expireDate,
              'DD.MM.YYYY'
            ).format('YYYY-MM-DD'),
            clientDocumentNumber: response.data?.idNum,
            clientDocumentIssuer:
              response.data?.issuingAuthority === 'МИНИСТЕРСТВО ЮСТИЦИИ' ? 2 : 1
          })
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  handleChange = name => event => {
    if (name === 'carVinCode' && !isAlphaNumeric(event.target.value)) {
      return
    }

    if (name === 'carVinCode' && event.target.value.length > 17) {
      return
    }

    if (name === 'clientIIN' && !isNumeric(event.target.value)) {
      return
    }

    if (name === 'clientIIN' && event.target.value.length > 12) {
      return
    }

    if (name === 'carMileage' && event.target.value.length > 6) {
      return
    }

    if (name === 'carYear' && event.target.value.length > 4) {
      return
    }

    if (name === 'carYear' && !isNumeric(event.target.value)) {
      return
    }

    if (name === 'clientDocumentNumber' && event.target.value.length > 10) {
      return
    }

    if (
      name === 'clientDocumentNumber' &&
      !isAlphaNumeric(event.target.value)
    ) {
      return
    }

    if (
      (name === 'contact1PhoneNumber' ||
        name === 'contact2PhoneNumber' ||
        name === 'contact3PhoneNumber') &&
      event.target.value.length > 16
    ) {
      return
    }

    this.setState(
      {
        [name]: event.target.value
      },
      () => {
        if (name === 'downPaymentAmount' || name === 'totalPrice') {
          let totalPrice = parseInt(this.state.totalPrice)
          let downPaymentAmount = parseInt(this.state.downPaymentAmount)

          this.setState({
            creditAmount: totalPrice - downPaymentAmount
          })
        }

        if (name === 'mainIncome' || name === 'spouseIncome') {
          let mainIncome = parseInt(this.state.mainIncome)
          let spouseIncome = parseInt(this.state.spouseIncome)

          this.setState({
            totalIncome: mainIncome + spouseIncome
          })
        }

        if (
          name === 'clientAddressStreet' ||
          name === 'clientAddressHouse' ||
          name === 'clientAddressApartmentNo'
        ) {
          let region =
            this.state.clientAddressRegion.nameRu === undefined
              ? ''
              : this.state.clientAddressRegion.nameRu
          let district =
            this.state.clientAddressDistrict.nameRu === undefined
              ? ''
              : this.state.clientAddressDistrict.nameRu
          this.setState({
            clientRegistrationAddress:
              region +
              ' ' +
              district +
              ' ' +
              this.state.clientAddressStreet +
              (this.state.clientAddressHouse !== '' ? ' д.' : '') +
              this.state.clientAddressHouse +
              (this.state.clientAddressApartmentNo !== '' ? ' кв.' : '') +
              this.state.clientAddressApartmentNo
          })
        }

        // if (
        //   name === 'creditPurpose' &&
        //   this.state.creditPurpose === 'Приобретение нового авто'
        // ) {
        //   this.setState({
        //     carYear: new Date().getFullYear()
        //   })
        // }
      }
    )

    if (
      name === 'clientRegistrationAddressEqualsActualAddress' &&
      event.target.value === 'Да'
    ) {
      this.setState({
        clientActualAddress: this.state.clientRegistrationAddress
      })
    } else if (
      name === 'clientRegistrationAddressEqualsActualAddress' &&
      event.target.value === 'Нет'
    ) {
      this.setState({
        clientActualAddress: ''
      })
    }
  }

  handleChangeRegion(type, event) {
    let region = this.state.regions.filter(
      region => region.code === event.target.value
    )

    this.setState({
      clientAddressRegion: region[0],
      clientAddressDistrict: '',
      clientAddressTown: ''
    })
    this.getDistricts(region[0].code)
    let district =
      this.state.clientAddressDistrict.nameRu === undefined
        ? ''
        : this.state.clientAddressDistrict.nameRu
    this.setState({
      clientRegistrationAddress:
        region[0].nameRu +
        ' ' +
        district +
        ' ' +
        this.state.clientAddressStreet +
        (this.state.clientAddressHouse !== '' ? ' д.' : '') +
        this.state.clientAddressHouse +
        (this.state.clientAddressApartmentNo !== '' ? ' кв.' : '') +
        this.state.clientAddressApartmentNo
    })
  }

  handleChangeDistrict(type, event) {
    let district = this.state.districts.filter(
      district => district.code === event.target.value
    )

    this.setState({
      clientAddressDistrict: district[0],
      clientAddressTown: ''
    })
    this.getTowns(district[0].code)
    this.setState({
      clientRegistrationAddress:
        this.state.clientAddressRegion.nameRu +
        ' ' +
        district[0].nameRu +
        ' ' +
        this.state.clientAddressStreet +
        (this.state.clientAddressHouse !== '' ? ' д.' : '') +
        this.state.clientAddressHouse +
        (this.state.clientAddressApartmentNo !== '' ? ' кв.' : '') +
        this.state.clientAddressApartmentNo
    })
  }

  handleChangeTown(type, event) {
    let town = this.state.towns.filter(town => town.code === event.target.value)
    this.setState({ clientAddressTown: town[0] })
    this.setState({
      clientRegistrationAddress:
        this.state.clientAddressRegion.nameRu +
        ' ' +
        this.state.clientAddressDistrict.nameRu +
        ' ' +
        this.state.clientAddressStreet +
        (this.state.clientAddressHouse !== '' ? ' д.' : '') +
        this.state.clientAddressHouse +
        (this.state.clientAddressApartmentNo !== '' ? ' кв.' : '') +
        this.state.clientAddressApartmentNo
    })
  }

  handleCreateCreditRequestClick(e) {
    e.preventDefault()

    if (!validateInput(this.state)) {
      return
    }

    let self = this
    axios
      .post(
        FB_API_URL + '/finbroker/credit_request/upsert',
        {
          // Сведения о кредите
          creditPurpose: this.state.creditPurpose,
          totalPrice: this.state.totalPrice,
          downPaymentAmount: this.state.downPaymentAmount,
          creditAmount: this.state.creditAmount,
          creditTerm: this.state.creditTerm,
          repaymentMethod: this.state.repaymentMethod,
          simplifiedFin: this.state.simplifiedFin,
          dealerName: this.state.dealerName,

          // Обеспечение
          carBrand: this.state.carBrand,
          carModel: this.state.carModel,
          carManufactureCountry: this.state.carManufactureCountry,
          carYear: this.state.carYear,
          carWheel: this.state.carWheel,
          carMileage: this.state.carMileage,
          carVinCode: this.state.carVinCode,

          // Сведения о Заемщике
          clientFirstname: this.state.clientFirstname,
          clientLastname: this.state.clientLastname,
          clientPatronymic: this.state.clientPatronymic,
          clientIIN: this.state.clientIIN,
          clientDateOfBirth: this.state.clientDateOfBirth,
          clientGender: this.state.clientGender,
          clientCitizenship: this.state.clientCitizenship,
          clientEducationLevel: this.state.clientEducationLevel,
          clientPlaceOfBirth: this.state.clientPlaceOfBirth,
          clientResidency: this.state.clientResidency,
          clientDocumentInfo: this.state.clientDocumentInfo,
          clientDocumentNumber: this.state.clientDocumentNumber,
          clientDocumentIssuer: this.state.clientDocumentIssuer,
          clientDocumentIssueDate: this.state.clientDocumentIssueDate,
          clientDocumentExpireDate: this.state.clientDocumentExpireDate,
          clientChangedName: this.state.clientChangedName,
          clientIsPledger: this.state.clientIsPledger,
          clientMaritalStatus: this.state.clientMaritalStatus,
          clientDependentsNumber: this.state.clientDependentsNumber,
          clientChildCount: this.state.clientChildCount,
          clientSpouseInfo:
            this.state.spouseLastname +
            ' ' +
            this.state.spouseFirstname +
            ' ' +
            this.state.spousePatronymic,
          clientRegistrationAddress: this.state.clientRegistrationAddress,
          clientAddressRegion: this.state.clientAddressRegion.code,
          clientAddressTown: this.state.clientAddressTown.code,
          clientAddressDistrict: this.state.clientAddressDistrict.code,
          clientAddressStreet: this.state.clientAddressStreet,
          clientAddressHouse: this.state.clientAddressHouse,
          clientAddressApartmentNo: this.state.clientAddressApartmentNo,
          clientActualAddress: this.state.clientActualAddress,
          clientRegistrationAddressEqualsActualAddress:
            this.state.clientRegistrationAddressEqualsActualAddress,
          clientRightOfResidence: this.state.clientRightOfResidence,
          clientMobilePhoneNumber: this.state.clientMobilePhoneNumber,
          clientWorkPhoneNumber: this.state.clientWorkPhoneNumber,

          // Информация по супругу/супруге
          spouseFirstname: this.state.spouseFirstname,
          spouseLastname: this.state.spouseLastname,
          spousePatronymic: this.state.spousePatronymic,
          spouseIIN: this.state.spouseIIN,
          spouseDateOfBirth: this.state.spouseDateOfBirth,

          // Информация о работе
          employerFullName: this.state.employerFullName,
          employerActivity: this.state.employerActivity,
          jobPositionCategory: this.state.jobPositionCategory,
          jobPosition: this.state.jobPosition,
          employmentStatus: this.state.employmentStatus,
          workExperienceInMonths: this.state.workExperienceInMonths,
          workExperienceInMonthsAtLastPosition:
            this.state.workExperienceInMonthsAtLastPosition,

          // Информация о среднемесячных доходах и расходах
          mainIncome: this.state.mainIncome,
          spouseIncome: this.state.spouseIncome,
          totalIncome: this.state.totalIncome,

          // Дополнительные контакты
          contact1Name: this.state.contact1Name,
          contact1PhoneNumber: this.state.contact1PhoneNumber,
          contact1Relationship: this.state.contact1Relationship,
          contact2Name: this.state.contact2Name,
          contact2PhoneNumber: this.state.contact2PhoneNumber,
          contact2Relationship: this.state.contact2Relationship,
          contact3Name: this.state.contact3Name,
          contact3PhoneNumber: this.state.contact3PhoneNumber,
          contact3Relationship: this.state.contact3Relationship,

          branchCode: this.state.branchCode,
          saleId:
            this.props.sale !== undefined &&
            this.props.sale !== null &&
            (this.props.sale.steps === null ||
              this.props.sale.steps === undefined)
              ? this.props.sale.id
              : null,
          saleIdNew:
            this.props.sale !== undefined &&
            this.props.sale !== null &&
            this.props.sale.steps !== null &&
            this.props.sale.steps !== undefined
              ? this.props.sale.id
              : null,
          saleGlobalId:
            this.props.sale !== undefined &&
            this.props.sale !== null &&
            this.props.sale.globalId !== null &&
            this.props.sale.globalId !== undefined
              ? this.props.sale.globalId
              : null,
          clientId:
            this.props.sale !== undefined && this.props.sale !== null
              ? this.props.sale.client.clientId
              : null
        },
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`
          }
        }
      )
      .then(function (response) {
        self.props.enqueueSnackbar('Кредитная заявка успешно создана!', {
          variant: 'success'
        })
        self.props.closeDialog()
      })
      .catch(function (error) {
        console.log(error.message)
      })
  }

  render() {
    console.log(this.props.sale)

    return (
      <div>
        <div style={{ textAlign: 'center' }}>
          <form>
            <div style={{ display: 'inline-block', marginBottom: '20px' }}>
              <Paper className="paper-nohover">
                <div>
                  <FormControl fullWidth={true} variant="outlined">
                    <InputLabel htmlFor="branchCode">Точка продаж</InputLabel>
                    <Select
                      className="textfield_green"
                      variant="filled"
                      value={this.state.branchCode}
                      onChange={this.handleChange('branchCode')}
                      input={<OutlinedInput labelWidth={120} />}
                    >
                      {this.state.userBranches.map(branch => (
                        <MenuItem
                          key={branch.branchCode}
                          value={branch.branchCode}
                        >
                          {branch.branchName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div style={{ textAlign: 'left', marginTop: '30px' }}>
                  <div className="title">Сведения о запрашиваемом кредите</div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    margin: 'auto',
                    flexBasis: '0',
                    width: '100%'
                  }}
                >
                  <div
                    style={{ flexGrow: '1', margin: '5px', minWidth: '320px' }}
                  >
                    <TextField
                      value={this.state.totalPrice}
                      InputProps={{
                        inputComponent: CustomNumberFormat,
                        className: 'textfield_green'
                      }}
                      fullWidth={true}
                      variant="outlined"
                      label="Сумма ДКП"
                      onChange={this.handleChange('totalPrice')}
                    />
                  </div>
                  <div
                    style={{ margin: '5px', flexGrow: '1', minWidth: '320px' }}
                  >
                    <TextField
                      value={this.state.downPaymentAmount}
                      InputProps={{
                        inputComponent: CustomNumberFormat,
                        className: 'textfield_green'
                      }}
                      fullWidth={true}
                      variant="outlined"
                      label="Сумма первоначального взноса"
                      onChange={this.handleChange('downPaymentAmount')}
                    />
                  </div>
                  <div
                    style={{ margin: '5px', flexGrow: '1', minWidth: '320px' }}
                  >
                    <TextField
                      value={this.state.creditAmount}
                      InputProps={{
                        inputComponent: CustomNumberFormat,
                        className: 'textfield_green'
                      }}
                      fullWidth={true}
                      variant="filled"
                      label="Сумма кредита"
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    margin: 'auto',
                    flexBasis: '0',
                    width: '100%'
                  }}
                >
                  <div
                    style={{
                      margin: '5px',
                      flexGrow: '1',
                      minWidth: '320px'
                    }}
                  >
                    <FormControl variant="outlined" fullWidth={true}>
                      <InputLabel htmlFor="city">Цель кредитования</InputLabel>
                      <Select
                        value={this.state.creditPurpose}
                        className="textfield_green"
                        onChange={this.handleChange('creditPurpose')}
                        input={<OutlinedInput labelWidth={240} />}
                      >
                        <MenuItem value={'Приобретение БУ авто'}>
                          Приобретение БУ авто
                        </MenuItem>
                        <MenuItem value={'Приобретение нового авто'}>
                          Приобретение нового авто
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    style={{ margin: '5px', flexGrow: '1', minWidth: '320px' }}
                  >
                    <TextField
                      value={this.state.creditTerm}
                      InputProps={{ className: 'textfield_green' }}
                      fullWidth={true}
                      variant="outlined"
                      type="number"
                      label="Срок кредита в месяцах"
                      onChange={this.handleChange('creditTerm')}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    margin: 'auto',
                    flexBasis: '0',
                    width: '100%'
                  }}
                >
                  <div
                    style={{
                      flexGrow: '1',
                      margin: '5px',
                      minWidth: '320px'
                    }}
                  >
                    <FormControl variant="outlined" fullWidth={true}>
                      <InputLabel htmlFor="repaymentMethod">
                        Метод погашения
                      </InputLabel>
                      <Select
                        variant="outlined"
                        value={this.state.repaymentMethod}
                        className="textfield_green"
                        onChange={this.handleChange('repaymentMethod')}
                        input={<OutlinedInput labelWidth={140} />}
                      >
                        <MenuItem value={'Аннуитетный'}>Аннуитетный</MenuItem>
                        <MenuItem value={'Дифференцированный'}>
                          Дифференцированный
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    style={{
                      margin: '5px',
                      flexGrow: '1',
                      minWidth: '320px'
                    }}
                  >
                    <FormControl variant="outlined" fullWidth={true}>
                      <InputLabel htmlFor="city">
                        С подтверждением дохода
                      </InputLabel>
                      <Select
                        value={this.state.simplifiedFin}
                        className="textfield_green"
                        onChange={this.handleChange('simplifiedFin')}
                        input={<OutlinedInput labelWidth={240} />}
                      >
                        <MenuItem value={'Да'}>Да</MenuItem>
                        <MenuItem value={'Нет'}>Нет</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    style={{ margin: '5px', flexGrow: '1', minWidth: '320px' }}
                  >
                    <FormControl variant="outlined" fullWidth={true}>
                      <InputLabel>Юридическое лицо по ДКП</InputLabel>
                      <Select
                        variant="filled"
                        value={this.state.dealerName}
                        className="textfield_green"
                        onChange={this.handleChange('dealerName')}
                        input={<OutlinedInput labelWidth={210} />}
                      >
                        <MenuItem value={'ТОО ASTER AUTO (АСТЭР АВТО)'}>
                          ТОО ASTER AUTO (АСТЭР АВТО)
                        </MenuItem>
                        <MenuItem
                          value={'ТОО "ASTER AUTO ASTANA (АСТЭР АВТО АСТАНА)"'}
                        >
                          ТОО "ASTER AUTO ASTANA (АСТЭР АВТО АСТАНА)"
                        </MenuItem>
                        <MenuItem value={'ТОО «ASTER AUTO Шымкент»'}>
                          ТОО «ASTER AUTO Шымкент»
                        </MenuItem>
                        <MenuItem value={'ТОО «Gold Star Motors»'}>
                          ТОО «Gold Star Motors»
                        </MenuItem>
                        <MenuItem value={'ТОО ОРИОН ДИСТРИБЬЮШН'}>
                          ТОО ОРИОН ДИСТРИБЬЮШН
                        </MenuItem>
                        <MenuItem value={'ТОО "Уральск Авторегион"'}>
                          ТОО "Уральск Авторегион"
                        </MenuItem>
                        <MenuItem value={'ТОО "Актау Авто Лидер"'}>
                          ТОО "Актау Авто Лидер"
                        </MenuItem>
                        <MenuItem value={'ТОО "Актобе Автодрайв"'}>
                          ТОО "Актобе Автодрайв"
                        </MenuItem>
                        <MenuItem value={'ТОО "Атырау Автосалон"'}>
                          ТОО "Атырау Автосалон"
                        </MenuItem>
                        <MenuItem value={'ТОО "Караганда Авто 09"'}>
                          ТОО "Караганда Авто 09"
                        </MenuItem>
                        <MenuItem value={'ТОО "Кокшетау Автоцентр"'}>
                          ТОО "Кокшетау Автоцентр"
                        </MenuItem>
                        <MenuItem value={'ТОО "Павлодар Автосупермаркет"'}>
                          ТОО "Павлодар Автосупермаркет"
                        </MenuItem>
                        <MenuItem value={'ТОО "Петропавловск Автосити"'}>
                          ТОО "Петропавловск Автосити"
                        </MenuItem>
                        <MenuItem value={'ТОО "Усть-Каменогорск Автомаркет"'}>
                          ТОО "Усть-Каменогорск Автомаркет"
                        </MenuItem>
                        <MenuItem value={'ТОО "Сарыарка АвтоПром"'}>
                          ТОО "Сарыарка АвтоПром"
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div style={{ textAlign: 'left', marginTop: '30px' }}>
                  <div className="title">Обеспечение</div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    margin: 'auto',
                    flexBasis: '0',
                    width: '100%'
                  }}
                >
                  {this.state.creditPurpose === 'Приобретение нового авто' && (
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl variant="outlined" fullWidth={true}>
                        <InputLabel htmlFor="city">Выбрать авто</InputLabel>
                        <Select
                          value={this.state.selectedCarName}
                          className="textfield_green"
                          onChange={e => this.populateNewCar(e.target.value)}
                          input={<OutlinedInput labelWidth={120} />}
                        >
                          {this.state.newCars.map(car => (
                            <MenuItem value={car.marka + '#' + car.model}>
                              {car.marka + ' ' + car.model}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  )}

                  {this.state.selectedCarsFromSale.length > 0 && (
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl variant="outlined" fullWidth={true}>
                        <InputLabel htmlFor="city">Выбрать авто</InputLabel>
                        <Select
                          value={this.state.selectedCarName}
                          className="textfield_green"
                          onChange={e =>
                            this.populateCarRelatedFields(e.target.value)
                          }
                          input={<OutlinedInput labelWidth={120} />}
                        >
                          {this.state.selectedCarsFromSale.map(car => (
                            <MenuItem value={car.id}>
                              {car.marka.name +
                                ' ' +
                                car.model.name +
                                ' ' +
                                car.year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  )}

                  <div
                    style={{ margin: '5px', flexGrow: '1', minWidth: '320px' }}
                  >
                    <TextField
                      value={this.state.carBrand}
                      InputProps={{ className: 'textfield_green' }}
                      fullWidth={true}
                      variant="outlined"
                      type="text"
                      label="Марка ТС"
                      onChange={this.handleChange('carBrand')}
                    />
                  </div>
                  <div
                    style={{ margin: '5px', flexGrow: '1', minWidth: '320px' }}
                  >
                    <TextField
                      value={this.state.carModel}
                      InputProps={{ className: 'textfield_green' }}
                      fullWidth={true}
                      variant="outlined"
                      type="text"
                      label="Модель ТС"
                      onChange={this.handleChange('carModel')}
                    />
                  </div>
                  <div
                    style={{ margin: '5px', flexGrow: '1', minWidth: '320px' }}
                  >
                    <TextField
                      value={this.state.carVinCode}
                      InputProps={{ className: 'textfield_green' }}
                      fullWidth={true}
                      variant="outlined"
                      type="text"
                      label="VIN код"
                      onChange={this.handleChange('carVinCode')}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    margin: 'auto',
                    flexBasis: '0',
                    width: '100%'
                  }}
                >
                  <div
                    style={{
                      flexGrow: '1',
                      margin: '5px',
                      minWidth: '320px'
                    }}
                  >
                    <FormControl fullWidth={true} variant="outlined">
                      <InputLabel htmlFor="wheel">Руль</InputLabel>
                      <Select
                        variant="filled"
                        value={this.state.carWheel}
                        onChange={this.handleChange('carWheel')}
                        className="textfield_green"
                        input={<OutlinedInput labelWidth={35} />}
                      >
                        <MenuItem value={'Левый'}>Левый</MenuItem>
                        <MenuItem value={'Правый'}>Правый</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    style={{
                      margin: '5px',
                      flexGrow: '1',
                      minWidth: '320px'
                    }}
                  >
                    <TextField
                      value={this.state.carMileage}
                      InputProps={{ className: 'textfield_green' }}
                      fullWidth={true}
                      variant="outlined"
                      type="number"
                      label="Пробег, км"
                      onChange={this.handleChange('carMileage')}
                    />
                  </div>
                  <div
                    style={{ margin: '5px', flexGrow: '1', minWidth: '320px' }}
                  >
                    <TextField
                      value={this.state.carYear}
                      InputProps={{ className: 'textfield_green' }}
                      fullWidth={true}
                      variant="outlined"
                      type="text"
                      label="Год выпуска"
                      onChange={this.handleChange('carYear')}
                    />
                  </div>
                  <div
                    style={{
                      flexGrow: '1',
                      margin: '5px',
                      minWidth: '320px'
                    }}
                  >
                    <FormControl fullWidth={true} variant="outlined">
                      <InputLabel htmlFor="city">
                        Страна производитель марки ТС
                      </InputLabel>
                      <Select
                        variant="filled"
                        value={this.state.carManufactureCountry}
                        onChange={this.handleChange('carManufactureCountry')}
                        className="textfield_green"
                        input={<OutlinedInput labelWidth={255} />}
                      >
                        <MenuItem value={'Япония'}>Япония</MenuItem>
                        <MenuItem value={'Германия'}>Германия</MenuItem>
                        <MenuItem value={'Франция'}>Франция</MenuItem>
                        <MenuItem value={'Италия'}>Италия</MenuItem>
                        <MenuItem value={'Южная Корея'}>Южная Корея</MenuItem>
                        <MenuItem value={'Китай'}>Китай</MenuItem>
                        <MenuItem value={'Россия'}>Россия</MenuItem>
                        <MenuItem value={'СНГ'}>СНГ</MenuItem>
                        <MenuItem value={'США'}>США</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div style={{ textAlign: 'left', marginTop: '30px' }}>
                  <div className="title">
                    <span>Сведения о заемщике</span>
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      component="label"
                      style={{ marginLeft: 12 }}
                    >
                      лицевая сторона
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        name="front"
                        onChange={this.handleUpload('front')}
                      />
                    </Button>
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      component="label"
                      style={{ marginLeft: 12 }}
                    >
                      оборотная сторона
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        name="back"
                        onChange={this.handleUpload('back')}
                      />
                    </Button>
                  </div>
                </div>
                <div style={{ flexDirection: 'column' }} className="mobile_tr">
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="ИИН"
                        variant="outlined"
                        value={this.state.clientIIN || ''}
                        onChange={this.handleChange('clientIIN')}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Фамилия"
                        variant="outlined"
                        value={this.state.clientLastname}
                        onChange={this.handleChange('clientLastname')}
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.clientFirstname}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        variant="outlined"
                        label="Имя"
                        onChange={this.handleChange('clientFirstname')}
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        label="Отчество"
                        variant="outlined"
                        value={this.state.clientPatronymic}
                        onChange={this.handleChange('clientPatronymic')}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '240px'
                      }}
                    >
                      <TextField
                        id="date"
                        variant="outlined"
                        InputProps={{
                          className: 'textfield_green',
                          inputProps: { max: '9999-01-01' }
                        }}
                        label="Дата рождения"
                        type="date"
                        fullWidth={true}
                        value={this.state.clientDateOfBirth}
                        onChange={this.handleChange('clientDateOfBirth')}
                        InputLabelProps={{ shrink: true }}
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '240px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">Пол</InputLabel>
                        <Select
                          className="textfield_green"
                          variant="filled"
                          value={this.state.clientGender}
                          onChange={this.handleChange('clientGender')}
                          input={<OutlinedInput labelWidth={30} />}
                        >
                          <MenuItem value={'M'}>Мужской</MenuItem>
                          <MenuItem value={'F'}>Женский</MenuItem>
                        </Select>
                      </FormControl>
                    </div>

                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '240px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">
                          Признак резиденства
                        </InputLabel>
                        <Select
                          className="textfield_green"
                          variant="outlined"
                          value={this.state.clientResidency}
                          onChange={this.handleChange('clientResidency')}
                          input={<OutlinedInput labelWidth={175} />}
                        >
                          <MenuItem value={'1'}>Резидент</MenuItem>
                          <MenuItem value={'0'}>Нерезидент</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">Гражданство</InputLabel>
                        <Select
                          className="textfield_green"
                          variant="filled"
                          value={this.state.clientCitizenship}
                          onChange={this.handleChange('clientCitizenship')}
                          input={<OutlinedInput labelWidth={100} />}
                        >
                          {COUNTRIES.map(country => (
                            <MenuItem value={country.countryName}>
                              {country.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">Образование</InputLabel>
                        <Select
                          className="textfield_green"
                          variant="filled"
                          value={this.state.clientEducationLevel}
                          onChange={this.handleChange('clientEducationLevel')}
                          input={<OutlinedInput labelWidth={100} />}
                        >
                          <MenuItem value={'Высшее'}>Высшее</MenuItem>
                          <MenuItem value={'Среднее'}>Среднее</MenuItem>
                          <MenuItem value={'Неоконченное высшее'}>
                            Неоконченное высшее
                          </MenuItem>
                          <MenuItem value={'Среднее специальное'}>
                            Среднее специальное
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">Место рождения</InputLabel>
                        <Select
                          className="textfield_green"
                          variant="filled"
                          value={this.state.clientPlaceOfBirth}
                          onChange={this.handleChange('clientPlaceOfBirth')}
                          input={<OutlinedInput labelWidth={130} />}
                        >
                          {COUNTRIES.map(country => (
                            <MenuItem value={country.countryName}>
                              {country.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">
                          Вид документа, уд.лич.
                        </InputLabel>
                        <Select
                          className="textfield_green"
                          variant="filled"
                          value={this.state.clientDocumentInfo || ''}
                          onChange={this.handleChange('clientDocumentInfo')}
                          input={<OutlinedInput labelWidth={175} />}
                        >
                          <MenuItem value={'01'}>
                            Паспорт гражданина РК
                          </MenuItem>
                          <MenuItem value={'04'}>
                            Удостоверение личности
                          </MenuItem>
                          <MenuItem value={'12'}>
                            Свидетельство о рождении
                          </MenuItem>
                          <MenuItem value={'13'}>
                            Удостоверение беженца
                          </MenuItem>
                          <MenuItem value={'03'}>
                            Паспорт иностранного гос-ва
                          </MenuItem>
                          <MenuItem value={'09'}>
                            Уд-ние лица без гражданства
                          </MenuItem>
                          <MenuItem value={'10'}>
                            Вид на жительство ин-ца в РК
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        multiline={true}
                        label="Номер документа, уд.лич."
                        variant="outlined"
                        value={this.state.clientDocumentNumber || ''}
                        onChange={this.handleChange('clientDocumentNumber')}
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">
                          Орган выдачи документа, уд.лич.
                        </InputLabel>
                        <Select
                          className="textfield_green"
                          variant="filled"
                          value={this.state.clientDocumentIssuer || ''}
                          onChange={this.handleChange('clientDocumentIssuer')}
                          input={<OutlinedInput labelWidth={250} />}
                        >
                          <MenuItem value={'1'}>МВД РК</MenuItem>
                          <MenuItem value={'2'}>МЮ РК</MenuItem>
                          <MenuItem value={'3'}>Иное</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        id="date"
                        variant="outlined"
                        InputProps={{
                          className: 'textfield_green',
                          inputProps: { max: '9999-01-01' }
                        }}
                        label="Дата выдачи документа"
                        type="date"
                        fullWidth={true}
                        value={this.state.clientDocumentIssueDate || ''}
                        onChange={this.handleChange('clientDocumentIssueDate')}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        id="date"
                        variant="outlined"
                        InputProps={{
                          className: 'textfield_green',
                          inputProps: { max: '9999-01-01' }
                        }}
                        label="Срок действия документа"
                        type="date"
                        fullWidth={true}
                        value={this.state.clientDocumentExpireDate || ''}
                        onChange={this.handleChange('clientDocumentExpireDate')}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        multiline={true}
                        label="Изменение ФИО"
                        variant="outlined"
                        value={this.state.clientChangedName}
                        onChange={this.handleChange('clientChangedName')}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '240px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">Залогодатель</InputLabel>
                        <Select
                          className="textfield_green"
                          variant="filled"
                          value={this.state.clientIsPledger}
                          onChange={this.handleChange('clientIsPledger')}
                          input={<OutlinedInput labelWidth={110} />}
                        >
                          <MenuItem value={'Да'}>Да</MenuItem>
                          <MenuItem value={'Нет'}>Нет</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '240px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">
                          Социальный статус
                        </InputLabel>
                        <Select
                          className="textfield_green"
                          variant="filled"
                          value={this.state.clientMaritalStatus}
                          onChange={this.handleChange('clientMaritalStatus')}
                          input={<OutlinedInput labelWidth={150} />}
                        >
                          <MenuItem value={'1'}>Холост/Не замужем</MenuItem>
                          <MenuItem value={'2'}>Женат/Замужем</MenuItem>
                          <MenuItem value={'3'}>Вдовец/Вдова</MenuItem>
                          <MenuItem value={'4'}>Разведен/Разведена</MenuItem>
                          <MenuItem value={'5'}>
                            Повторно женат/замужем
                          </MenuItem>
                          <MenuItem value={'6'}>Гражданский брак</MenuItem>
                          <MenuItem value={'0'}>Не определено</MenuItem>
                          <MenuItem value={'7'}>Иное</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '240px'
                      }}
                    >
                      <TextField
                        value={this.state.clientDependentsNumber}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        variant="outlined"
                        type="number"
                        label="Количество иждивенцев"
                        onChange={this.handleChange('clientDependentsNumber')}
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '240px'
                      }}
                    >
                      <TextField
                        value={this.state.clientChildCount}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        variant="outlined"
                        type="number"
                        label="Количество детей"
                        onChange={this.handleChange('clientChildCount')}
                      />
                    </div>
                  </div>

                  {['2', '5'].includes(this.state.clientMaritalStatus) && (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        margin: 'auto',
                        flexBasis: '0',
                        width: '100%'
                      }}
                    >
                      <div
                        style={{
                          flexGrow: '1',
                          margin: '5px',
                          minWidth: '320px'
                        }}
                      >
                        <TextField
                          InputProps={{ className: 'textfield_green' }}
                          fullWidth={true}
                          label="ИИН супруга/супруги"
                          variant="outlined"
                          value={this.state.spouseIIN}
                          onChange={this.handleChange('spouseIIN')}
                        />
                      </div>
                      <div
                        style={{
                          margin: '5px',
                          flexGrow: '1',
                          minWidth: '240px'
                        }}
                      >
                        <TextField
                          id="date"
                          variant="outlined"
                          InputProps={{ className: 'textfield_green' }}
                          label="Дата рождения супруга/супруги"
                          type="date"
                          fullWidth={true}
                          defaultValue={this.state.spouseDateOfBirth}
                          onChange={this.handleChange('spouseDateOfBirth')}
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                    </div>
                  )}
                  {['2', '5'].includes(this.state.clientMaritalStatus) && (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        margin: 'auto',
                        flexBasis: '0',
                        width: '100%'
                      }}
                    >
                      <div
                        style={{
                          flexGrow: '1',
                          margin: '5px',
                          minWidth: '320px'
                        }}
                      >
                        <TextField
                          InputProps={{ className: 'textfield_green' }}
                          fullWidth={true}
                          label="Фамилия супруга/супруги"
                          variant="outlined"
                          value={this.state.spouseLastname}
                          onChange={this.handleChange('spouseLastname')}
                        />
                      </div>
                      <div
                        style={{
                          margin: '5px',
                          flexGrow: '1',
                          minWidth: '320px'
                        }}
                      >
                        <TextField
                          value={this.state.spouseFirstname}
                          InputProps={{ className: 'textfield_green' }}
                          fullWidth={true}
                          variant="outlined"
                          label="Имя супруга/супруги"
                          onChange={this.handleChange('spouseFirstname')}
                        />
                      </div>
                      <div
                        style={{
                          flexGrow: '1',
                          margin: '5px',
                          minWidth: '320px'
                        }}
                      >
                        <TextField
                          InputProps={{ className: 'textfield_green' }}
                          fullWidth={true}
                          label="Отчество супруга/супруги"
                          variant="outlined"
                          value={this.state.spousePatronymic}
                          onChange={this.handleChange('spousePatronymic')}
                        />
                      </div>
                    </div>
                  )}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">
                          {this.state.clientAddressRegion !== '' &&
                          (this.state.clientAddressRegion.code ===
                            '750000000' ||
                            this.state.clientAddressRegion.code ===
                              '710000000' ||
                            this.state.clientAddressRegion.code === '790000000')
                            ? 'Город'
                            : 'Область'}
                        </InputLabel>
                        <Select
                          className="textfield_green"
                          variant="filled"
                          value={this.state.clientAddressRegion.code}
                          onChange={this.handleChangeRegion.bind(
                            this,
                            'client'
                          )}
                          input={<OutlinedInput labelWidth={65} />}
                        >
                          {this.state.regions.map(region => {
                            return (
                              <MenuItem value={region.code}>
                                {region.nameRu}
                              </MenuItem>
                            )
                          })}
                        </Select>
                      </FormControl>
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      {this.state.clientAddressRegion && (
                        <FormControl
                          disabled={!this.state.clientAddressRegion}
                          fullWidth={true}
                          variant="outlined"
                        >
                          <InputLabel htmlFor="city">Район</InputLabel>
                          <Select
                            className="textfield_green"
                            variant="filled"
                            value={this.state.clientAddressDistrict.code}
                            onChange={this.handleChangeDistrict.bind(
                              this,
                              'client'
                            )}
                            input={<OutlinedInput labelWidth={55} />}
                          >
                            {this.state.clientAddressRegion &&
                              this.state.districts.map(district => {
                                return (
                                  <MenuItem value={district.code}>
                                    {district.nameRu}
                                  </MenuItem>
                                )
                              })}
                          </Select>
                        </FormControl>
                      )}
                    </div>
                    {this.state.clientAddressDistrict !== '' &&
                    this.state.clientAddressRegion !== '' &&
                    this.state.clientAddressRegion.code !== '750000000' &&
                    this.state.clientAddressRegion.code !== '710000000' &&
                    this.state.clientAddressRegion.code !== '790000000' ? (
                      <div
                        style={{
                          margin: '5px',
                          flexGrow: '1',
                          minWidth: '320px'
                        }}
                      >
                        <FormControl fullWidth={true} variant="outlined">
                          <InputLabel htmlFor="city">Город</InputLabel>
                          <Select
                            className="textfield_green"
                            variant="filled"
                            value={this.state.clientAddressTown.code}
                            onChange={this.handleChangeTown.bind(
                              this,
                              'client'
                            )}
                            input={<OutlinedInput labelWidth={65} />}
                          >
                            {this.state.towns.map(town => (
                              <MenuItem value={town.code}>
                                {town.nameRu}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        multiline={true}
                        label="Улица"
                        variant="outlined"
                        value={this.state.clientAddressStreet}
                        onChange={this.handleChange('clientAddressStreet')}
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '160px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        multiline={true}
                        label="Номер дома"
                        variant="outlined"
                        value={this.state.clientAddressHouse}
                        onChange={this.handleChange('clientAddressHouse')}
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '160px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        multiline={true}
                        label="Номер квартиры"
                        variant="outlined"
                        value={this.state.clientAddressApartmentNo}
                        onChange={this.handleChange('clientAddressApartmentNo')}
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        multiline={true}
                        label="Адрес регистрации"
                        variant="filled"
                        value={this.state.clientRegistrationAddress}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">
                          Адрес фактического проживания совпадает с адресом
                          регистрации?
                        </InputLabel>
                        <Select
                          className="textfield_green"
                          value={
                            this.state
                              .clientRegistrationAddressEqualsActualAddress
                          }
                          onChange={this.handleChange(
                            'clientRegistrationAddressEqualsActualAddress'
                          )}
                          input={<OutlinedInput labelWidth={320} />}
                        >
                          <MenuItem value={'Да'}>Да</MenuItem>
                          <MenuItem value={'Нет'}>Нет</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">Право проживания</InputLabel>
                        <Select
                          className="textfield_green"
                          input={<OutlinedInput labelWidth={150} />}
                          value={this.state.clientRightOfResidence}
                          onChange={this.handleChange('clientRightOfResidence')}
                        >
                          <MenuItem value={'Собственная квартира'}>
                            Собственная квартира
                          </MenuItem>
                          <MenuItem value={'Проживаю с родственниками'}>
                            Проживаю с родственниками
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        multiline={true}
                        label="Адрес фактического проживания"
                        variant="outlined"
                        value={this.state.clientActualAddress}
                        onChange={this.handleChange('clientActualAddress')}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <InputMask
                        mask="+7 999 999 99 99"
                        value={this.state.clientMobilePhoneNumber}
                        disabled={false}
                        maskChar="-"
                        onChange={this.handleChange('clientMobilePhoneNumber')}
                      >
                        {() => (
                          <TextField
                            label="Мобильный телефон"
                            fullWidth={true}
                            variant="outlined"
                            InputProps={{ className: 'textfield_green' }}
                          />
                        )}
                      </InputMask>
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <InputMask
                        mask="+7 999 999 99 99"
                        value={this.state.clientWorkPhoneNumber}
                        disabled={false}
                        maskChar="-"
                        onChange={this.handleChange('clientWorkPhoneNumber')}
                      >
                        {() => (
                          <TextField
                            label="Рабочий телефон"
                            fullWidth={true}
                            variant="outlined"
                            InputProps={{ className: 'textfield_green' }}
                          />
                        )}
                      </InputMask>
                    </div>
                  </div>

                  <div style={{ textAlign: 'left', marginTop: '30px' }}>
                    <div className="title">Информация о работе</div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.employerFullName}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        variant="outlined"
                        label="Полное наименование компании/организации"
                        onChange={this.handleChange('employerFullName')}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">
                          Вид деятельности организации
                        </InputLabel>
                        <Select
                          className="textfield_green"
                          input={<OutlinedInput labelWidth={240} />}
                          value={this.state.employerActivity}
                          onChange={this.handleChange('employerActivity')}
                        >
                          {EMPLOYER_ACTIVITY.map(employerActivity => (
                            <MenuItem value={employerActivity.name}>
                              {employerActivity.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">
                          Категория занимаемой должности
                        </InputLabel>
                        <Select
                          className="textfield_green"
                          input={<OutlinedInput labelWidth={270} />}
                          value={this.state.jobPositionCategory}
                          onChange={this.handleChange('jobPositionCategory')}
                        >
                          <MenuItem value={'1'}>Старший специалист</MenuItem>
                          <MenuItem value={'2'}>
                            Управление (нач. отдела, управления)
                          </MenuItem>
                          <MenuItem value={'3'}>
                            Общее управление организацией
                          </MenuItem>
                          <MenuItem value={'4'}>Специалист</MenuItem>
                          <MenuItem value={'5'}>Рабочий</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.jobPosition}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        variant="outlined"
                        label="Должность"
                        onChange={this.handleChange('jobPosition')}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">Статус занятости</InputLabel>
                        <Select
                          className="textfield_green"
                          input={<OutlinedInput labelWidth={130} />}
                          value={this.state.employmentStatus}
                          onChange={this.handleChange('employmentStatus')}
                        >
                          <MenuItem value={'1'}>Временно безработный</MenuItem>
                          <MenuItem value={'2'}>Безработный</MenuItem>
                          <MenuItem value={'3'}>На пенсии</MenuItem>
                          <MenuItem value={'4'}>Работа по найму</MenuItem>
                          <MenuItem value={'5'}>Собственный бизнес</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div
                      style={{
                        margin: '5px',
                        flexGrow: '1',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.workExperienceInMonths}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        type="number"
                        variant="outlined"
                        label="Стаж работы общий (мес)"
                        onChange={this.handleChange('workExperienceInMonths')}
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.workExperienceInMonthsAtLastPosition}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        type="number"
                        variant="outlined"
                        label="Стаж на последнем месте работы (мес)"
                        onChange={this.handleChange(
                          'workExperienceInMonthsAtLastPosition'
                        )}
                      />
                    </div>
                  </div>
                  <div style={{ textAlign: 'left', marginTop: '30px' }}>
                    <div className="title">
                      Информация о среднемесячных доходах и расходах
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.mainIncome}
                        InputProps={{
                          inputComponent: CustomNumberFormat,
                          className: 'textfield_green'
                        }}
                        fullWidth={true}
                        variant="outlined"
                        label="Доходы от основной деятельности"
                        onChange={this.handleChange('mainIncome')}
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.spouseIncome}
                        InputProps={{
                          inputComponent: CustomNumberFormat,
                          className: 'textfield_green'
                        }}
                        fullWidth={true}
                        variant="outlined"
                        label="Дополнительный доход"
                        onChange={this.handleChange('spouseIncome')}
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.totalIncome}
                        InputProps={{
                          inputComponent: CustomNumberFormat,
                          className: 'textfield_green'
                        }}
                        fullWidth={true}
                        variant="filled"
                        label="Всего совокупный доход"
                      />
                    </div>
                  </div>

                  <div style={{ textAlign: 'left', marginTop: '30px' }}>
                    <div className="title">Дополнительные контакты</div>
                  </div>
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '20px' }}>Контактное лицо #1</div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.contact1Name}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        variant="outlined"
                        label="ФИО"
                        onChange={this.handleChange('contact1Name')}
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <InputMask
                        mask="+7 999 999 99 99"
                        value={this.state.contact1PhoneNumber}
                        disabled={false}
                        maskChar="-"
                        onChange={this.handleChange('contact1PhoneNumber')}
                      >
                        {() => (
                          <TextField
                            label="Номер телефона"
                            fullWidth={true}
                            variant="outlined"
                            InputProps={{ className: 'textfield_green' }}
                          />
                        )}
                      </InputMask>
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">Тип родства</InputLabel>
                        <Select
                          className="textfield_green"
                          variant="filled"
                          value={this.state.contact1Relationship}
                          onChange={this.handleChange('contact1Relationship')}
                          input={<OutlinedInput labelWidth={100} />}
                        >
                          <MenuItem value={'9'}>Коллега</MenuItem>
                          <MenuItem value={'7'}>Сын</MenuItem>
                          <MenuItem value={'4'}>Сестра</MenuItem>
                          <MenuItem value={'1'}>Муж</MenuItem>
                          <MenuItem value={'3'}>Брат</MenuItem>
                          <MenuItem value={'5'}>Мать</MenuItem>
                          <MenuItem value={'6'}>Отец</MenuItem>
                          <MenuItem value={'2'}>Жена</MenuItem>
                          <MenuItem value={'8'}>Дочь</MenuItem>
                          <MenuItem value={'11'}>Друг/Подруга</MenuItem>
                          <MenuItem value={'10'}>Другой родственник</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '20px' }}>Контактное лицо #2</div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.contact2Name}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        variant="outlined"
                        label="ФИО"
                        onChange={this.handleChange('contact2Name')}
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <InputMask
                        mask="+7 999 999 99 99"
                        value={this.state.contact2PhoneNumber}
                        disabled={false}
                        maskChar="-"
                        onChange={this.handleChange('contact2PhoneNumber')}
                      >
                        {() => (
                          <TextField
                            label="Номер телефона"
                            fullWidth={true}
                            variant="outlined"
                            InputProps={{ className: 'textfield_green' }}
                          />
                        )}
                      </InputMask>
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">Тип родства</InputLabel>
                        <Select
                          className="textfield_green"
                          variant="filled"
                          value={this.state.contact2Relationship}
                          onChange={this.handleChange('contact2Relationship')}
                          input={<OutlinedInput labelWidth={100} />}
                        >
                          <MenuItem value={'9'}>Коллега</MenuItem>
                          <MenuItem value={'7'}>Сын</MenuItem>
                          <MenuItem value={'4'}>Сестра</MenuItem>
                          <MenuItem value={'1'}>Муж</MenuItem>
                          <MenuItem value={'3'}>Брат</MenuItem>
                          <MenuItem value={'5'}>Мать</MenuItem>
                          <MenuItem value={'6'}>Отец</MenuItem>
                          <MenuItem value={'2'}>Жена</MenuItem>
                          <MenuItem value={'8'}>Дочь</MenuItem>
                          <MenuItem value={'11'}>Друг/Подруга</MenuItem>
                          <MenuItem value={'10'}>Другой родственник</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '20px' }}>Контактное лицо #3</div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      margin: 'auto',
                      flexBasis: '0',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <TextField
                        value={this.state.contact3Name}
                        InputProps={{ className: 'textfield_green' }}
                        fullWidth={true}
                        variant="outlined"
                        label="ФИО"
                        onChange={this.handleChange('contact3Name')}
                      />
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <InputMask
                        mask="+7 999 999 99 99"
                        value={this.state.contact3PhoneNumber}
                        disabled={false}
                        maskChar="-"
                        onChange={this.handleChange('contact3PhoneNumber')}
                      >
                        {() => (
                          <TextField
                            label="Номер телефона"
                            fullWidth={true}
                            variant="outlined"
                            InputProps={{ className: 'textfield_green' }}
                          />
                        )}
                      </InputMask>
                    </div>
                    <div
                      style={{
                        flexGrow: '1',
                        margin: '5px',
                        minWidth: '320px'
                      }}
                    >
                      <FormControl fullWidth={true} variant="outlined">
                        <InputLabel htmlFor="city">Тип родства</InputLabel>
                        <Select
                          className="textfield_green"
                          variant="filled"
                          value={this.state.contact3Relationship}
                          onChange={this.handleChange('contact3Relationship')}
                          input={<OutlinedInput labelWidth={100} />}
                        >
                          <MenuItem value={'9'}>Коллега</MenuItem>
                          <MenuItem value={'7'}>Сын</MenuItem>
                          <MenuItem value={'4'}>Сестра</MenuItem>
                          <MenuItem value={'1'}>Муж</MenuItem>
                          <MenuItem value={'3'}>Брат</MenuItem>
                          <MenuItem value={'5'}>Мать</MenuItem>
                          <MenuItem value={'6'}>Отец</MenuItem>
                          <MenuItem value={'2'}>Жена</MenuItem>
                          <MenuItem value={'8'}>Дочь</MenuItem>
                          <MenuItem value={'11'}>Друг/Подруга</MenuItem>
                          <MenuItem value={'10'}>Другой родственник</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
                <div style={{ textAlign: 'left' }}>
                  <Button
                    style={{ margin: '5px', marginTop: '20px' }}
                    type="submit"
                    className="button"
                    onClick={this.handleCreateCreditRequestClick.bind(this)}
                  >
                    Сохранить
                  </Button>
                </div>
              </Paper>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default flowRight(withSnackbar)(CreateCreditRequest)
